export default "__VITE_PUBLIC_ASSET__ba92489f__"